export const translatorFromApi = {
    'Something went wrong!' : 'invalidCredentials',
    'FAILED': 'failed',
    'LOADED': 'loaded',
    'LOADING': 'loading',
    'NOT_AVAILABLE': 'notAvailable',
    'NONE': 'none',
    'Exist email': 'existEmail',
    'Exist Company Name': 'existCompanyName',
    'SAVING': 'saving',
    'SAVED': 'saved'
};